import PriceAdjust from './PriceAdjust.container';

export default PriceAdjust;
